import { InputAdornment, TextField, TextFieldProps } from "@material-ui/core";
import { forwardRef } from "react";
import { NumberFormatProps } from "react-number-format";
import NumberFormat from "react-number-format";

const CustomNumericFormat = forwardRef<NumberFormatProps>((props, ref) => {
  return (
    <NumberFormat
      {...props}
      getInputRef={ref}
      decimalScale={0}
      allowLeadingZeros={false}
      thousandSeparator
    />
  );
});

export type CurrencyInputProps = TextFieldProps & {};

export default function CurrencyInput(props: CurrencyInputProps) {
  return (
    <TextField
      {...props}
      InputProps={{
        startAdornment: <InputAdornment position="start">₪</InputAdornment>,
        inputComponent: CustomNumericFormat as never,
        ...props?.InputProps
      }}
    />
  );
}
